import { useCallback, useState } from "react";

export function useAppUrl() {
    const [ appUrl ] = useState(document.querySelector('meta[name="app:url"]').getAttribute('content') || 'https://yoodesign.com.tw');

    const withAppUrl = useCallback((path) => {
        const pathWithSlash = path.startsWith('/') ? path : `/${path}`;
        return `${appUrl}${pathWithSlash}`;
    }, [appUrl]);

    return {
        appUrl,
        withAppUrl
    };
}